module.exports = __webpack_public_path__ + "static/media/chats-right.c02a8da6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/howItWorks/chats-right.svg
// module id = 123
// module chunks = 0